import React from "react";
import ReadIcon from "../../img/readIconOpen.png";

export const EnvelopCircleIconOpen = (props) => {
  const imgclassName = props?.className ? props?.className : "df-w-42";

  return (
    <>
      <img src={ReadIcon} className={imgclassName} />
    </>
  );
};
